import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'RoutingPolicy'
})
export class RoutingPolicyPipe implements PipeTransform {

  readonly routingPolicyOptionsBetweenGroups = {
    STICKY_PRIMARY: 'Sticky primary',
    STICKY_LAST_AVAILABLE: 'Sticky last available',
    ROUND_ROBIN: 'Round-robin'
  };

  transform(policy: string): any {
    return this.routingPolicyOptionsBetweenGroups[policy];
  }

}
